<template>
  <div class="buy-cabinet-container">
    <div class="create-host">
      <div class="jc-page-header">
        <div class="jc-container">
          <h1>
            <a href="javascript:void(0)" @click="jump_to_up()">
              <i class="el-icon-arrow-left"></i>
            </a>{{$t('create.text.buy')}}
          </h1>
        </div>
      </div>
      <div class="jc-page-content">
        <div class="jc-container" style="position:relative;">
          <div class="buildTab">
            <ul>
              <li id="tab1" class="hover">
                {{$t('create.text.yearlyOrMonthly')}}
              </li>
            </ul>
          </div>
          <div class="buildCon" id="con-tab-1" style="display: block;">
            <div class="infoBox">
              <!-- 地域与托管区 -->
              <div class="jc-form-section">
                <div class="jc-form-section-header">
                  <h3 class="jc-form-section-title">{{$t('create.text.regionAndAz')}}</h3>
                </div>
                <el-form class="jc-form cps-create-form" label-width="130px">
                  <!--地域-->
                  <el-form-item :label="$t('create.text.region') | withColon">
                    <el-radio-group v-model="selectedRegion">
                      <el-radio-button v-for="(regionName,region,index) in regions" :key="index"
                                       :label="region">
                        {{regionName}}
                      </el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                  <!--托管区-->
                  <el-form-item :label="$t('create.text.az') | withColon">
                    <el-radio-group v-model="selectedAz">
                      <el-radio-button v-for="(item,index) in zones[selectedRegion]"
                                       :key="index" :label="item.clz">
                        {{item.clzName}}
                      </el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                  <!--数据中心-->
                  <el-form-item :label="$t('create.text.dc') | withColon">
                    <el-radio-group v-model="selectedDc">
                      <el-radio-button  v-if='item.clz === selectedAz'
                                        v-for="(item,index) in zones[selectedRegion]"
                                        :label="item.dataCenter" :key="index">
                        {{item.dataCenterName}}
                      </el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-form>
              </div>
              <!-- 规格类型 -->
              <div class="jc-form-section">
                <div class="jc-form-section-header">
                  <h3 class="jc-form-section-title">{{$t('create.text.specs')}}</h3>
                </div>
                <el-form class="jc-form cps-create-form" label-width="130px">
                  <!--机型-->
                  <el-form-item :label="$t('create.text.cabinetType') | withColon">
                    <div class="jc-form-box">
                      <div style="overflow:hidden;margin-right:-30px;width: 100%">
                        <el-table :data="deviceTypesTable"
                                  class="instance-type"
                                  style="width: 700px"
                                  border>
                          <!-- 规格类型 -->
                          <el-table-column min-width="200" prop="name"
                                           :label="$t('create.text.specs')">
                            <template slot-scope="scope">
                              <el-radio-group v-if="!deviceTypesNum[scope.row.productCode]"
                                              :disabled="!deviceTypesNum[scope.row.productCode]"
                                              v-model="selectedCabinetSpec"
                                              @click="selectStandard(scope.row.productCode)">
                                <el-radio :label="scope.row.productCode">
                                  <span v-html="scope.row.name"></span>
                                </el-radio>
                              </el-radio-group>
                              <el-tooltip placement="bottom-start"
                                          v-if="!deviceTypesNum[scope.row.productCode]">
                                <span class="sold-out">{{$t('create.text.soldOut')}}</span>
                                <div slot="content" class="sold-out-tip" style="max-width:200px;">
                                  <span
                                    v-if="selectedNumber >1 && !deviceTypesNum[scope.row.productCode]">
                                    {{$t('create.help.notEnough')}}</span>
                                  <span v-else>{{$t('create.help.soldOut')}}</span>
                                  {{$t('create.help.orContact')}}
                                </div>
                              </el-tooltip>
                              <el-radio-group v-else
                                              :disabled="!deviceTypesNum[scope.row.productCode]"
                                              v-model="selectedCabinetSpec"
                                              @click="selectStandard(scope.row.productCode)">
                                <el-radio :label="scope.row.productCode">{{scope.row.name}}
                                </el-radio>
                              </el-radio-group>
                            </template>
                          </el-table-column>
                          <!-- 规格 -->
                          <el-table-column min-width="150" prop="productCode"
                                           :label="$t('create.text.spec')">
                            <template slot-scope="scope">
                              <span>
                                {{scope.row.productCode | maybeEmpty}}
                              </span>
                            </template>
                          </el-table-column>
                          <!-- 机柜空间 -->
                          <el-table-column prop="cpuDetail" min-width="150"
                                           :label="$t('create.text.cabinetRoom')">
                            <template slot-scope="scope">
                              <span>
                                {{scope.row.height | maybeEmpty}}
                              </span>
                            </template>
                          </el-table-column>
                          <!-- 额度电流 -->
                          <el-table-column prop="memConcise" min-width="150"
                                           :label="$t('create.text.current')">
                            <template slot-scope="scope">
                              <span>
                                {{scope.row.ratedCurrent | maybeEmpty}}
                              </span>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </div>
                  </el-form-item>
                </el-form>
              </div>
              <!-- 购买量 -->
              <div class="jc-form-section">
                <div class="jc-form-section-header">
                  <h3 class="jc-form-section-title">{{$t('create.text.buyNum')}}</h3>
                </div>
                <el-form class="jc-form cps-create-form" label-width="130px">
                  <!--购买时长-->
                  <el-form-item :label="$t('create.text.buyTimeSpan')| withColon">
                    <div class="my-time-length">
                      <span style="display:block;float:left;height:30px;line-height:30px;"></span>
                      <div class="time-slide">
                        <ul class="time-choose cl">
                            <li v-for='index in twoYears' @click="selectYear(index)"
                                class="time-discount"
                                :class="getClass(index)">
                              <i></i>{{index + $tc('create.text.year', index)}}
                            </li>
                        </ul>
                      </div>
                    </div>
                  </el-form-item>
                  <!--购买数量-->
                  <el-form-item :label="$t('create.text.count')| withColon">
                    <el-input-number v-model="selectedNumber" :min="1" :max="maxHostNumber"
                                     label="" @change="changeSelectedNumber"></el-input-number>
                    <el-tooltip style="margin-left:10px" effect="dark" placement="right">
                      <div slot="content" class="my-app-tip">
                        {{$t('create.hover.count')}}
                      </div>
                      <a><i class="el-icon-question"></i></a>
                    </el-tooltip>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
          <!-- 已选配置 -->
          <div id="selected" class="jc-form-create-selected"
               style="background-color:#F4F4F4;position:absolute;padding:10px;margin-left:915px;top:30px;margin-top:40px;width:265px; ">
            <h3 style="border-bottom:1px solid #e7e7e7;padding:10px 0px;font-size:14px;">
              {{$t('create.text.selectedConfig')}}</h3>
            <el-form label-width="70px" class="jc-datashow-list">
              <!--地域-->
              <el-form-item :label="$t('create.text.region')">
                <p v-if="regions[selectedRegion]">
                  {{regions[selectedRegion]}}
                </p>
                <p v-else>--</p>
              </el-form-item>
              <!--托管区-->
              <el-form-item :label="$t('create.text.az')" :title="$t('create.text.az')">
                <p v-if="zones[selectedRegion] !== undefined">
                  {{zones[selectedRegion][selectedAz]['clzName']}}
                </p>
                <p v-else>--</p>
              </el-form-item>
              <!--数据中心-->
              <el-form-item :label="$t('create.text.dc')" :title="$t('create.text.dc')">
                <p class="selected-ellipsis"
                   v-if="zones[selectedRegion] !== undefined"
                   :title="zones[selectedRegion][selectedAz]['dataCenterName']">
                  {{zones[selectedRegion][selectedAz]['dataCenterName']}}
                </p>
                <p v-else>--</p>
              </el-form-item>
              <!--规格-->
              <el-form-item :label="$t('create.text.spec')" :title="$t('create.text.spec')">
                <p v-if="selectedSpecDetail">
                  {{selectedSpecDetail}}
                </p>
                <p v-else>--</p>
              </el-form-item>
              <!--购买时长-->
              <el-form-item :label="$t('create.text.buyTimeSpan')">
                <p v-if="selectedYear">
                  {{selectedYear}} {{$tc('create.text.yearUnit', selectedYear)}}</p>
                <p v-else>--</p>
              </el-form-item>
              <!--购买数量-->
              <el-form-item :label="$t('create.text.buyNum')">
                <p>{{selectedNumber}}</p>
              </el-form-item>
              <!--费用-->
              <el-form-item :label="$t('create.text.cost')">
                <p class="form-item-nopadding" :class="[totalDiscount > 0?'':'form-item-bottom' ]">
                  <span class="price" style="color:#ff9600">￥{{discountedTotalPrice}}</span>
                  <span style="display:none;">{{calTotalPrice.discountedTotalPrice}}</span>
                </p>
              </el-form-item>
              <p v-if="totalDiscount > 0"
                 class="form-item-nopadding form-item-bottom selected-ellipsis">
                <span style="width:70px" class="jc-form-item__label"
                      :title="$t('create.text.original')">{{$t('create.text.original')}}</span>
                <span class="price"
                      style="font-size:12px;text-decoration:line-through;margin:6px 0;margin-left:11px">￥{{totalPrice}}</span>
                <span style="margin-left:20px;color:#ff9600;" :title="'￥'+ totalDiscount">{{$t('create.text.save')}}：￥{{totalDiscount}}</span>
              </p>
              <el-button type="primary" size="large"
                         :disabled="isBuyButtonDisabled"
                         class="my-buy-btn" @click="buy()">{{isBuyTag}}
              </el-button>
              <!--没有实名认证-->
              <p v-if="!isCertification" style="color:red;margin-top:10px;">
                {{$t('create.help.noCertification')}}
                <a :href="Config.REALNAME_URL">
                  {{$t('create.help.goCertificate')}}</a>
              </p>
              <!--实名认证了，库存不足-->
              <p v-else-if="!isStockEnough" style="color:red;margin-top:10px;">
                <span
                  v-if="cacheDeviceTypesNum[selectedCabinetSpec]">{{$t('create.help.restock')}}</span>
                <span v-else>{{$t('create.help.soldOut')}}</span>{{$t('create.help.contact')}}
              </p>
              <!--实名认证了，库存不足，没选机型-->
              <p v-else-if="isStockEnough && selectedCabinetSpec == ''"
                 style="color:red;margin-top:10px;">
                <!--库存不足(买了多台)-->
                <span
                  v-if="cacheDeviceTypesNum[selectedCabinetSpec]">{{$t('create.help.restock')}}</span>
                <span v-else>{{$t('create.help.soldOut')}}</span>{{$t('create.help.contact')}}
              </p>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCookie from 'vue-cookie';
import {
  OrderTypeConstant,
  ChargeModeConstant,
  ChargeUnitConstant,
} from '@/common/Constants';

export default {
  components: {
  },
  data() {
    return {
      quotaNumber: 0,
      // 所选地域
      selectedRegion: '',
      // 所选托管区
      selectedAz: '',
      // 数据中心
      selectedDc: '',
      // 所选机柜类型
      selectedCabinetSpec: '',
      // 已选配置中规格的详细信息
      selectedSpecDetail: '',
      // 所有的机柜规格放在一个对象中
      deviceTypes: {},
      // 购买数量
      selectedNumber: 1,
      // 最大购买数量
      maxHostNumber: 10,
      // 实名认证
      isCertification: true,
      isBuyTag: this.$t('create.text.buyNow'),
      // 是否是购买中
      isBuyIng: false,
      // 库存
      isStockEnough: true,
      // 价格
      discountedTotalPrice: 0,
      totalPrice: 0,
      totalDiscount: 0,
      // 可选地域
      regions: {},
      // 可选托管区
      zones: {},
      // 可选数据中心
      dcs: [],
      // 不同规格类型的库存数量
      deviceTypesNum: {},
      cacheDeviceTypesNum: {},
      // 规格类型列表
      deviceTypesTable: [],
      // 用于页面倒叙展示规格
      deviceTypesArr: [],
      timeUnit: 4, // 计费时长单位 1:小时 2:天 3:月 4:年,
      chargeUnit: 3, // 月
      billingType: 3, // 计费类型 1:按配置 2:按用量 3:包年包月 1.9只支持 包年包月
      selectedYear: 1, // 选择年份,
      allSold: true,
      scrolled: false,
      // 2年
      twoYears: [1, 2],
      clientToken: Normal.getClientToken(), // 时间戳,
      initDc: '',
      initRegion: '',
      initAz: '',
    };
  },
  created() {
    this.getRegion();
    this.getPrivilegeNew();
    this.initTimePlugin();
    this.init();
  },
  mounted() {
    // this.initTimePlugin();
    this.init();
  },
  watch: {
    selectedRegion (newValue) {
      if (newValue) {
        if (newValue !== this.initRegion) {
          if (this.zones[this.selectedRegion]) {
            for (const item in this.zones[this.selectedRegion]) {
              this.selectedAz = item;
              break;
            }
          } else {
            this.selectedAz = '';
          }
        } else {
          this.selectedAz = this.initAz;
        }
      }
    },
    selectedAz (newValue) {
      if (newValue) {
        if (newValue !== this.initAz) {
          this.selectedDc = this.zones[this.selectedRegion][this.selectedAz].dataCenter;
        } else {
          this.selectedDc = this.initDc;
        }
      }
    },
    selectedDc (newValue) {
      // 切换地域购买数量置换为1
      this.selectedNumber = 1;
      if (newValue) {
        this.getCabinetSpecs();
        if (this.initDc !== newValue) {
          this.selectedCabinetSpec = '';
        } else {
          this.selectedCabinetSpec = this.$route.query.productCode;
        }
      }
    },
    deviceTypesNum (newValue) {
      const flag = false;
      if (newValue === 1) {
        for (const key in newValue) {
          if (newValue[key]) {
            this.flag = true;
          }
        }
        this.stockEnough = flag;
      }
    },

    // 所选规格变化，重新计算已选配置中的规格、重新计算当前所选规格是否有库存
    selectedCabinetSpec (newValue, oldValue) {
      if (newValue === '') {
        this.selectedSpecDetail = '';
      } else if (this.selectedDc !== '') {
        this.getCabinetSpecs().then(() => {
          if (this.deviceTypes[newValue] !== undefined) {
            this.selectedSpecDetail = `${this.selectedCabinetSpec
            }(${this.deviceTypes[newValue].name} ${
              this.deviceTypes[newValue].ratedCurrent} ${
              this.deviceTypes[newValue].height})`;
          }
        }); 
      }
      if (newValue !== oldValue) {
        this.checkStockEnough(this.selectedCabinetSpec, this.selectedNumber);
      }
    },
    // 购买数量变化，重新计算库存
    selectedNumber (newValue) {
      for (let i = 0; i < this.deviceTypesArr.length; i++) {
        this.checkStockEnough(this.selectedCabinetSpec, newValue);
      }
    }
  },
  computed: {
    calTotalPrice () {
      return this.calculateTotalPrice();
    },
    ChargeModeConstant: () => ChargeModeConstant,
    OrderTypeConstant: () => OrderTypeConstant,
    ChargeUnitConstant: () => ChargeUnitConstant,
    // 立即购买按钮置灰
    isBuyButtonDisabled() {
      return !this.isStockEnough || !this.selectedCabinetSpec || !this.isCertification
          || this.isBuyIng;
    }
  },
  methods: {
    // 只能输入整数
    changeSelectedNumber(val) {
      clearTimeout(this.iptTimeout);
      this.iptTimeout = setTimeout(() => {
        let v = Math.floor(val);
        if (isNaN(v) || v <= 0) {
          v = 1;
        }
        this.selectedNumber = Math.floor(val);
      }, 200);
    },
    /**
       * 主要是切换可用区为cn-north-1b时
       * 初始化loginType及相关绑定值
       * 其余zoneChange事件见watch
       */
    zoneChange(zone) {
      if (zone === 'cn-north-1b') {
        this.passwordType = 'custom';
      }
    },
    getClass(num) {
      // 中文环境下样式
      if (VueCookie.get('jdcloud_sitelang') === 'cn'
          || VueCookie.get('jdcloud_sitelang') === null) {
        if (num === this.selectedYear) {
          return 'cur';
        } if (this.selectedYear > num) {
          return 'sel';
        } 
        return '';
      }
      // 英文环境下样式
      if (VueCookie.get('jdcloud_sitelang') === 'en') {
        if (num === this.selectedYear) {
          if (this.selectedYear === 1) {
            return 'curSingleEn curEn';
          } 
          return 'curEn';
        } if (this.selectedYear > num) {
          return 'sel';
        } 
        return '';
      }
    },
    getRegion() {
      this.$api.buyCabinet.getCabinetRegions({ all: 1, idcLine: this.GLOBAL.IDCLINE })
        .then((res) => {
          const data = res.data;
          if (res.errno === 10000 && res.errmsg === 'OK') {
            if (data && data.regions.length > 0 && data.regions[0] != null) {
              this.regions = {};
              for (const item of data.regions) {
                const region = item.region;
                const regionName = item.regionName;
                const clzs = item.clzs;
                this.regions[region] = regionName;
                for (const thing of clzs) {
                  const clz = thing.clz;
                  const clzName = thing.clzName;
                  const dataCenter = thing.dataCenter;
                  const dataCenterName = thing.dataCenterName;
                  if (typeof this.zones[region] === 'undefined') {
                    this.zones[region] = {};
                  }
                  this.zones[region][clz] = {
                    'clzName': clzName,
                    'clz': clz,
                    'dataCenter': dataCenter,
                    'dataCenterName': dataCenterName,
                  };
                }
              }
              const passedProductCode = this.$route.query.productCode;
              if (passedProductCode !== undefined) {
                this.selectedCabinetSpec = passedProductCode;
                this.$api.buyCabinet.getCabinetSpecification({ productCode: passedProductCode })
                  .then((res) => {
                    const data = res.data.specification;
                    this.initDc = data.dataCenter;
                    this.initRegion = data.region;
                    this.initAz = data.clz;
                    this.selectedRegion = data.region;
                    this.selectedAz = data.clz;
                    this.selectedDc = data.dataCenter;
                    this.selectedSpecDetail = `${data.productCode}(${data.name} ${
                      data.ratedCurrent} ${data.height})`;
                  });
              } else {
                this.selectedRegion = data.regions[0].region;
                this.selectedAz = data.regions[0].clzs[0].clz;
                this.selectedDc = data.regions[0].clzs[0].dataCenter;
              }
            } else {
              this.regions = {};
            }
          } else {
            this.$message.error(res.errmsg);
          }
        });
    },
    /**
       **@disc: 获取用户实名认证信息
       */
    getPrivilegeNew() {
      this.$api.buyCabinet.getRealNameAuthentication({})
        .then((res) => {
          const data = res.data;
          // 0 未认证 1 个人认证通过 2 企业认证通过 3 个人和企业认证都通过
          if ([2, 3].includes(data)) {
            this.isCertification = true;
          } else {
            this.isCertification = false;
          }
        });
    },
    /**
       **@disc: 查询库存
       */
    checkStockEnough(selectedCabinetSpec, selectedNumber, init) {
      // init 用来区分是不是初始化,不是初始化,则不用传值,是初始化则传true
      if (!selectedCabinetSpec) {
        return;
      }
      const params = {
        productCode: selectedCabinetSpec,
        count: selectedNumber
      };
      this.$api.buyCabinet.getCabinetStock(params)
        .then((res) => {
          const data = res.data;
          this.deviceTypesNum[selectedCabinetSpec] = data;
          const newDeviceTypesNum = Object.assign({}, this.deviceTypesNum);
          this.deviceTypesNum = Object.assign({}, newDeviceTypesNum);
          if (init) {
            this.cacheDeviceTypesNum[selectedCabinetSpec] = data;
            const cacheDeviceTypesNum = Object.assign({}, this.cacheDeviceTypesNum);
            this.cacheDeviceTypesNum = Object.assign({}, cacheDeviceTypesNum);
            this.cacheDeviceTypesNum[''] = false;
          }
          if (this.deviceTypesNum[this.selectedCabinetSpec] !== undefined) {
            this.isStockEnough = this.deviceTypesNum[this.selectedCabinetSpec];
          }
        });
    },
    /**
       **@disc: 计算总价
       */
    calculateTotalPrice() {
      if (!this.selectedRegion || !this.selectedCabinetSpec) {
        return '';
      }
      this.discountedTotalPrice = this.$t('create.text.calculating');
      this.totalPrice = this.$t('create.text.calculating');
      this.totalDiscount = this.$t('create.text.calculating');
      const params = {
        cmd: 1, // 创建
        region: this.selectedRegion, // 区域
        clz: this.selectedAz, // 托管区
        dataCenter: this.selectedDc, // 数据中心
        timeUnit: this.timeUnit, // 年
        timeSpan: this.selectedYear,
        count: this.selectedNumber,
        billingType: this.billingType,
        productCode: this.selectedCabinetSpec,
      };
      // 计价的时候立即购买置灰
      this.isBuyIng = true;
      // 如果不是整数不计价
      if (!/^\d+$/.test(this.selectedNumber)) {
        return false;
      }
      this.$api.buyCabinet.getCabinetTotalPrice(params)
        .then((res) => {
          const data = res.data;
          this.discountedTotalPrice = data.discountedTotalPrice;
          this.totalPrice = data.totalPrice;
          this.totalDiscount = data.totalDiscount;
          // 计价成功可以立即购买
          this.isBuyIng = false;
          return '';
        });
      return '';
    },
    /**
       **@disc: 所选规格
       */
    selectStandard(standard) {
      if (!this.deviceTypesNum[standard]) {
        return;
      }
      this.selectedCabinetSpec = standard;
    },
    /**
       **@disc: 选择年份
       */
    selectYear(selYear) {
      this.selectedYear = selYear;
    },
    initTimePlugin() {
      $('.time-choose li').click(function () {
        if (VueCookie.get('jdcloud_sitelang') == 'cn') {
          $('.time-choose li').removeClass('cur').removeClass('sel');
          $(this).addClass('cur');
        } else if (VueCookie.get('jdcloud_sitelang') == 'en') {
          $('.time-choose li').removeClass('curEn').removeClass('sel');
          $(this).addClass('curEn');
        }
      });
      $(this).prevAll().addClass('sel');
    },
    init() {
      $('.mainCon').scroll(function () {
        if ($(this).scrollTop() > 140) {
          $('.jc-form-create-selected').css({ 'position': 'fixed', 'top': '10px' });
        } else {
          $('.jc-form-create-selected').css({ 'position': 'absolute', 'top': '30px' });
        }
      });
    },
    /**
       **@disc: 点击立即购买
       */
    buy() {
      const params = {
        productCode: this.selectedCabinetSpec,
        count: this.selectedNumber
      };
      this.$api.buyCabinet.getCabinetStock(params)
        .then((res) => {
          const data = res.data;
          if (data === true) {
            this.isStockEnough = true;
            // 创建临时订单
            this.createOrder();
          } else {
            this.isStockEnough = false;
          }
        });
    },
    /**
       **@disc: 创建临时订单
       */
    createOrder() {
      const param = {
        orderType: OrderTypeConstant[1], // 订单类型 新购
        region: this.selectedRegion,
        clz: this.selectedAz,
        dataCenter: this.selectedDc,
        productCode: this.selectedCabinetSpec,
        chargeMode: ChargeModeConstant[3], // 计费类型 包年包月
        chargeDuration: this.selectedYear,
        chargeUnit: ChargeUnitConstant[4], // 计费时间单位 年
        quantity: this.selectedNumber,
        specification: this.selectedSpecDetail,
        clientToken: this.clientToken,
        timestamps: this.clientToken,
      };
      this.$api.buyCabinet.submitTempOrder(param)
        .then((res) => {
          // 成功提交临时订单，立即购买按钮置灰，防止重复提交
          this.isBuyIng = true;
          const buyId = res.data.buyId;
          if (buyId !== '' && buyId !== undefined) {
            window.location.href = `${this.Config.ORDER_URL}/confirm?buyId=${buyId}&source=1`;
          }
        })
        .catch(async (err) => {
          const { response } = err.data;
          try {
            const json = await response.json();
            this.$message.error(json.errmsg);
          } catch (ex) {
            console.log(ex);
          }
        });
    },
    /**
       **@disc: 获取机柜类型
       **@author: mengln
       **@params:
       */
    async getCabinetSpecs() {
      this.deviceTypesArr = [];
      const params = { dataCenter: this.selectedDc };
      await this.$api.buyCabinet.getCabinetSpecs(params)
        .then((res) => {
          const deviceTypes = {};
          const deviceTypesNum = {};
          const data = res.data;
          this.deviceTypesArr = data.specifications;
          this.$nextTick(() => {
            this.deviceTypesTable = data.specifications;
            for (const item of data.specifications) {
              const nameEN = item.productCode;
              deviceTypes[nameEN] = item;
              this.deviceTypesNum[nameEN] = 1;
            }
          });
          for (let z = 0; z < this.deviceTypesArr.length; z++) {
            this.checkStockEnough(this.deviceTypesArr[z].productCode, this.selectedNumber, true);
          }
          this.deviceTypes = deviceTypes;
          this.deviceTypesNum = deviceTypesNum;
          if (!this.selectedCabinetSpec) {
            this.selectedCabinetSpec = this.deviceTypesArr[0].productCode;
          }
        });
    },
  }
};
</script>
<style lang="scss">
  @import 'style';
</style>



// WEBPACK FOOTER //
// src/components/buyCabinet/BuyCabinet.vue